import { render, staticRenderFns } from "./sectionHeader.vue?vue&type=template&id=2e4bcc46&scoped=true&"
import script from "./sectionHeader.vue?vue&type=script&lang=js&"
export * from "./sectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./sectionHeader.vue?vue&type=style&index=0&id=2e4bcc46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4bcc46",
  null
  
)

export default component.exports